import { BrandliveEvent, Session } from "../../../types/working-model";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getStartTime } from '../../../utils/get-event-start-time';
import { Status } from '../../../types/event';
import { getEventLink } from './event-card';

interface Props {
	event: BrandliveEvent;
	eventRegistrations?: number;
}

export default function EventRow(props: Props): JSX.Element {

	const { event, eventRegistrations } = props;

	const [isLive, setIsLive] = useState(false);

	useEffect(() => {
		if (event) {
			const date = Date.now();
			event.sessions.map((session: Session) => {
				const timestamp = new Date(session.timestamp!);
				const end_timestamp = new Date(session.end_timestamp!);
				const start = timestamp.getTime();
				const end = end_timestamp.getTime();
				if (start < date && end > date) {
					setIsLive(true);
				}
			});
		}
	}, [event]);

	function getStatus() {
		if (isLive) {
			return (
				<div className="list-status live">
					{"Live"}
				</div>
			);
		}
		switch (event?.status) {
			case 0: {
				return (
					<div className="list-status">
						{Status[event.status]}
					</div>
				);
			}
			case 1: {
				return (
					<div className="list-status">
						{Status[event.status]}
					</div>
				);
			}
			case 2: {
				return (
					<div className="list-status unpublished">
						{Status[event.status]}
					</div>
				);
			}
			default: {
				return (
					<div className="list-status error">
						{"None"}
					</div>
				);
			}
		}
	}

	return (
		<>
			<div className="list-title">
				<Link to={getEventLink(event)}>{event.name}</Link>
			</div>
			<div>
				{getStartTime(event, true)}
			</div>
			<div>
				{eventRegistrations}
			</div>
			{getStatus()}
		</>
	);
}